import React, { useState, useEffect, useCallback } from "react";
import QueryString from "query-string";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import ShopFullCard from "@/components/shop/card-full";
import FilterItem from "@/components/shop/filter-item";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import FrontBanner from "@/assets/images/front-banner.svg";
import avtar from "@/assets/images/avtar.svg";
import { samples, filters, emptyFilters } from "./data.js";
import { plans } from "../../utils/constants.js";
import { ROUTESLIST } from "@/static/urls";
import "./index.scss";

const ShopPage = ({ userDashboardView = false }) => {
  const history = useHistory();
  const [cartItems, setCartItems] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);

  // Load cart from localStorage on mount
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartItems(storedCart);
    calculateTotal(storedCart);
  }, []);

  const calculateTotal = (items) => {
    const total = items.reduce((sum, item) => {
      const price = item.price || 0;
      const quantity = item.quantity || 1;
      return sum + price * quantity;
    }, 0);
    setCartTotal(total);
  };

  const removeFromCart = (id) => {
    const updatedCart = cartItems.filter((item) => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(updatedCart));
    setCartItems(updatedCart);
    calculateTotal(updatedCart);
  };
  
  const goToPlans = () => {
    history.push(ROUTESLIST.SUBSCRIPTIONS);
  };

  return (
    <main className="page page-shop">
      <div
        className="product-section"
        style={userDashboardView ? { margin: "0rem" } : { margin: "5rem" }}
      >
        <div
          className="product-header"
          style={
            userDashboardView
              ? { justifyContent: "center" }
              : { justifyContent: "space-between" }
          }
        >
          {!userDashboardView && (
            <div
              className="back-to-home-section"
              onClick={() => {
                history.push(ROUTESLIST?.SUBSCRIPTIONS);
              }}
            >
              <ArrowBackIcon />
              {/* <h3>Back to home</h3> */}
            </div>
          )}

          <div className="back-to-home-section-image">
            <img src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg" alt="front-banner" />
          </div>
          {!userDashboardView && (
            <div className="back-to-home-section">
              <img src={avtar} alt="Avatar" className="avatar" />
            </div>
          )}
        </div>
        <div className="subscription-section">
          <div className="subscription-section-center">
            <h3>Subscription</h3>
            <div className="card-parent">
              <ul>
                

              {cartItems.length === 0 ? (
                <p>Your cart is empty.</p>
              ) : (
                <>
                  {cartItems.map((item) => (
                    <li key={item.id}><div className="subscription-detail" >
                <div className="plan-name">
                  <h3>{item.name}</h3>
                  {/* <button
                    onClick={() => {
                      goToPlans();
                    }}
                    className="btn btn-primary change-plan"
                  >
                    Change Plan
                  </button> */}
                </div>
                <div className="plan-price">
                  <h3>${item.price}</h3>
                  <span>{item.price ? "USD" : ""}</span>
                  <p>{item.description}</p>
                </div>
                <div className="divider"></div>
                <div className="plan-points">
                  <ul className="plan-points-ul">
                    {item.features?.map((feature) => {
                      return <li>{feature}</li>;
                    })}
                  </ul>
                </div>
                    </div> </li>
                  ))}
                </>
              )}
              </ul>


              <div className="subscription-subtotal">
                  <h3>Bill Summary</h3>
                  {cartItems.map((item) => (
                    <div className="summary-details">
                      <h3>1x {item.name}</h3>
                      <p>${item.price}</p>
                    </div>
                  ))}
                <div className="divider"></div>
                <div className="tax-details">
                  <div className="vat-details">
                    <p>VAT</p>
                    <p>$12.47</p>
                  </div>
                  <div className="vat-details">
                    <p>Discount</p>
                    <p>-$12.47</p>
                  </div>
                </div>
                <div className="divider"></div>
                <div className="payable-amout">
                  <p>Total Payable Amount</p>
                    <h3>${cartTotal}</h3>
                </div>
                <div className="checkout">
                  <button
                    className="btn btn-primary checkout-btn"
                    onClick={() => {
                      history && history.push(ROUTESLIST.CHECKOUT);
                      // handleCheckout
                    }}
                  >
                    Checkout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ShopPage;
